import { render, staticRenderFns } from "./VideoMeeting.vue?vue&type=template&id=06444325&scoped=true&"
import script from "./VideoMeeting.vue?vue&type=script&lang=js&"
export * from "./VideoMeeting.vue?vue&type=script&lang=js&"
import style0 from "./VideoMeeting.vue?vue&type=style&index=0&id=06444325&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06444325",
  null
  
)

export default component.exports